module.exports = __webpack_public_path__ + "static/media/th3_level_2.32f326ba.png";